module.exports = __webpack_public_path__ + "media/icons/skrzynia-manualna-grey-7b21a7a6.png";